import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import Toast from 'i2kjslibrary/plugins/vuetify/toast/toast.js';
import Confirm from 'i2kjslibrary/plugins/vuetify/confirm/confirm.js';
import Wait from 'i2kjslibrary/plugins/vuetify/wait/wait';

import i2kFunctions from 'i2kjslibrary/functions';

import Functions from "@/utils/functions.js";
import Load from "./LOAD.js"

import './assets/css/style.css'

import 'floating-vue/dist/style.css'
import {
  VTooltip,
} from 'floating-vue'
Vue.directive('tooltip', VTooltip)

// Vuetify
Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#2196F3'
      },
      dark: {
        primary: '#2196F3',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
}

//main color: #2196F3

// Plugins
Vue.use(Toast, { version: 2 })
Vue.use(Confirm, { version: 2, titleBackground: '#2196F3' })
Vue.use(Wait, { version: 2 })

// Prototype
Vue.prototype.$functions = Functions;
Vue.prototype.$i2kFunctions = i2kFunctions;
Vue.prototype.$load = Load;

Vue.config.productionTip = false


new Vue({
  render: h => h(App),
  router,
  store,
  vuetify: new Vuetify(opts)
}).$mount('#app')